<mat-toolbar class="flex-align-items-center" color="primary">
	<h2>Announcements</h2>

	<div class="ml-auto flex-align-items-center">
		<button mat-icon-button (click)="announcementsFacade.close()">
			<mat-icon> close </mat-icon>
		</button>
	</div>
</mat-toolbar>
